import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';


import { ProcessType, CacheService } from 'mapfre-auditlib';
import * as _ from 'lodash';
import { Observable, of, Subject } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class ProcessTypeService {

  className = 'ProcessTypeService';

  memoryCache: any = {
    "processTypes": {
      "data": null,
      "lastReqDate": null
    },
    "processTypesValoration": {
      "data": null,
      "lastReqDate": null
    }
  }

  constructor(private http: HttpClient, private cacheService: CacheService) {
  }

  getAllProcessTypes(cache = true, cacheKey = "processTypes"): Observable<ProcessType[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<ProcessType[]>(environment.base_URL + "/types-processes").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getAllProcessTypesValoration(cache = true, cacheKey = "processTypesValoration"): Observable<ProcessType[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<ProcessType[]>(environment.base_URL + "/types-valoration-process").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newProcessType(newProcessType: ProcessType) {
    return this.http.post(environment.base_URL + "/types-processes", newProcessType);
  }

  updateProcessType(editedProcessType) {
    return this.http.put(environment.base_URL + `/types-processes/${_.get(editedProcessType, 'idTypeProcessPk')}`, editedProcessType)
  }

  deleteProcessType(id) {
    return this.http.delete(environment.base_URL + `/types-processes/${id}`)
  }

  canUseCache(key) {
    let oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
    let canUse = false;
    if (moment().diff(oldDate, 'minutes') <= 1) {
      canUse = true;
    }
    return canUse;
  }

  updateCacheData(data, key) {
    _.set(this.memoryCache, `${key}.data`, data);
    _.get(this.memoryCache, `${key}._subject`).next(data);
  }

  updateCacheReq(key) {
    let _subject = new Subject<any>();
    let observer = _subject.asObservable();
    _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
  }
}
